import { css } from "styled-components";
import { colors } from "./colors";

export const textStyles = {
	carouselLabel: css`
		font-family: Sora;
		font-style: normal;
		font-weight: 700;
		font-size: 16px;
		line-height: 21px;
		color: #000000;
		cursor: pointer;
	`,
	primary: css`
		color: ${colors.textPrimary};
		font-size: 0.9375rem;
	`,
	primaryMedium: css`
		font-family: Sora;
		color: ${colors.textPrimary};
		font-size: 0.9375rem;
		font-weight: 600;
	`,
	primaryBold: css`
		font-family: Sora;
		color: ${colors.textPrimary};
		font-size: 0.9375rem;
		font-weight: 700;
	`,
	secondary: css`
		color: ${colors.textSecondary};
		font-size: 0.9375rem;
	`,
	tertiary: css`
		color: ${colors.textTertiary};
		font-size: 0.8125rem;
		font-weight: 600;
	`,
	text: css`
		color: ${colors.textPrimary};
		font-size: 0.8125rem;
		font-weight: 700;
	`,
	light: css`
		color: ${colors.textPrimary};
		font-size: 0.8125rem;
		font-weight: 500;
	`,
	lighter: css`
		color: ${colors.textSecondary};
		font-size: 0.8125rem;
		font-weight: 500;
	`,
	label: css`
		color: ${colors.textSecondary};
		font-size: 0.8125rem;
		font-weight: 700;
	`,
	titleBig: css`
		color: ${colors.textPrimary};
		font-size: 2.5rem;
		font-weight: 600;
		font-family: Sora;
		@media (max-width: 900px) {
			font-size: 1.875rem;
		}
	`,
	title: css`
		color: ${colors.textPrimary};
		font-size: 1.5625rem;
		font-weight: 700;
		font-family: Sora;
		@media (max-width: 900px) {
			font-size: 1.25rem;
		}
	`,
	description: css`
		color: ${colors.textPrimary};
		font-size: 1.5625rem;
		@media (max-width: 900px) {
			font-size: 1.25rem;
		}
	`,
	headersTitle: css`
		font-family: Sora;
		font-style: normal;
		font-weight: 600;
		font-size: 24px;
		line-height: 33px;
		/* identical to box height */
		text-align: center;
		color: ${colors.black};
		@media (max-width: 900px) {
			font-size: 1.25rem;
		}
	`,
	simpleDescription: css`
		font-style: normal;
		font-weight: 400;
		font-size: 1rem;
	`,
	headersDescription: css`
		font-family: Sora;
		font-style: normal;
		font-weight: 600;
		font-size: 24px;
		line-height: 33px;
		/* identical to box height */
		text-align: center;
		color: ${colors.black};
		@media (max-width: 900px) {
			font-size: 1.25rem;
		}
	`,
	desktopSubtitle: css`
		color: ${colors.textPrimary};
		font-size: 1.25rem;
		font-weight: 700;
		font-family: Sora;
		@media (max-width: 900px) {
			font-size: 0.9375rem;
		}
	`,
	subtitle: css`
		color: ${colors.textPrimary};
		font-size: 1.25rem;
		font-weight: 700;
		font-family: Sora;
	`,
	subdescription: css`
		color: ${colors.textPrimary};
		font-size: 1.25rem;
		font-weight: 700;
		font-family: Sora;
	`,
	small: css`
		color: ${colors.textPrimary};
		font-size: 0.625rem;
		font-weight: 700;
	`,
	smalldescription: css`
		color: ${colors.textPrimary};
		font-size: 0.875rem;
		font-weight: 400;
	`,
	secondaryFontFamily: css`
		font-family: Sora;
	`,
} as const;

export type TextStyles = typeof textStyles;
